// @flow
import React from 'react';
import cx from 'classnames';
import { FaFacebookSquare, FaGoogle, FaVimeo } from 'react-icons/fa';

import './SocialLoginButton.scss';

type Props = {
  type: 'facebook' | 'google' | 'naver',
  onSocialLogin(provider: string): void,
};

const providers = {
  facebook: {
    icon: FaFacebookSquare,
  },
  google: {
    icon: FaGoogle,
  },
  naver: {
    icon: FaVimeo,
  },
};

const SocialLoginButton = (props: Props) => {
  const { type, onSocialLogin } = props;
  const { icon: Icon } = providers[type];

  return (
    <div className={cx('social-login-button', type)} onClick={() => onSocialLogin(type)}>
      <div className="icon">
        <Icon />
      </div>
    </div>
  );
};

SocialLoginButton.defaultProps = {
  type: 'naver',
};

export default SocialLoginButton;



// WEBPACK FOOTER //
// ./src/components/auth/SocialLoginButton/SocialLoginButton.js